import React, { useState, useContext, useMemo, useCallback } from 'react';
import { colorBrand } from 'styles/layout/colors';
import IconMapMarker from 'components/icons/IconMapMarker';
import avo from 'analytics/avo';
import useProductCardContext from 'data-hooks/useProductCardContext';
import CategoryStoresContext from 'data-hooks/context/CategoryStoresContext';
import ProductCardMultipleStoresModal from './ProductCardMultipleStoresModal';

const ProductCardOnDisplayInShowroomMultiple = () => {
  const productCardContext = useProductCardContext();
  const { storesLookup, productStoresMap, productDistancesMap } = useContext(
    CategoryStoresContext
  );
  const [modalOpen, setModalOpen] = useState(false);

  const productId = productCardContext?.id;

  const stores = useMemo(() => {
    const storeIds = productStoresMap[productId] || [];
    const distances = productDistancesMap[productId] || [];

    if (!storeIds || storeIds.length === 0) return [];

    return storeIds
      .map((storeId, index) => {
        const storeData = storesLookup[storeId];
        if (!storeData) return null;

        return {
          storeData,
          distance: distances[index] || 0,
        };
      })
      .filter(Boolean);
  }, [productId, productStoresMap, productDistancesMap, storesLookup]);

  const toggleModal = useCallback(() => {
    if (!modalOpen) {
      const firstStore = stores[0];
      const firstStoreLocation = `${firstStore?.storeData?.city}, ${firstStore?.storeData?.state}`;
      const hasMultipleStores = stores.length > 1;
      const remainingCount = stores.length - 1;
      const displayText = hasMultipleStores
        ? `${firstStoreLocation} +${remainingCount} more`
        : firstStoreLocation;
      avo.ctaClicked({
        text: `On display in ${displayText}`,
        targetUrl: '',
        cta: 'Retail Store',
        component: 'Side Panel',
        location: 'Category Page',
      });
    }
    setModalOpen(!modalOpen);
  }, [modalOpen, stores]);

  if (!stores || stores.length === 0) {
    return null;
  }

  const firstStore = stores[0];
  const firstStoreLocation = `${firstStore?.storeData?.city}, ${firstStore?.storeData?.state}`;
  const hasMultipleStores = stores.length > 1;
  const remainingCount = stores.length - 1;

  return (
    <div className="text-xs font-bold text-brand pb-1 text-left md:p-0">
      <button
        className="flex flex-col md:flex-row md:items-center items-start text-xs font-bold text-brand pb-1 text-left md:p-0"
        onClick={toggleModal}
        type="button"
        aria-label="Open Showroom"
      >
        <span className="text-xs font-bold text-gray-light2">
          On display in&nbsp;
        </span>
        <span className="text-xs font-bold text-brand hover:no-underline flex space-x-1 items-center">
          <span>
            <IconMapMarker height={12} width={12} color={colorBrand} />
          </span>
          <span>
            {firstStoreLocation}
            {hasMultipleStores && (
              <span className="text-gray-light2 ml-2">
                +{remainingCount} more
              </span>
            )}
          </span>
        </span>
      </button>

      <ProductCardMultipleStoresModal
        stores={stores}
        onClose={() => setModalOpen(false)}
        isOpen={modalOpen}
      />
    </div>
  );
};

export default ProductCardOnDisplayInShowroomMultiple;
